<template>
  <!-- Code Postal -->
  <InputText
    :label="codePostalLabel"
    :slug="codePostalSlug"
    :model="codePostal"
    :v$="v$"
    @input="$emit('updateCodePostal',$event.target.value)"
  />

  <!-- Ville -->
  <InputSelect
    :label="villeLabel"
    :slug="villeSlug"
    :model="ville"
    :options="cities"
    :v$="v$"
    @input="$emit('updateVille', $event.target.value)"
  />
</template>

<script>
import InputText from "src/modules/shared/components/Form/InputText"
import InputSelect from "src/modules/shared/components/Form/InputSelect"
import {toRefs, watch} from "vue";
import useCityRepositories from 'src/modules/shared/composable/useCityRepositories'

export default {
  name: "ZipCodeAndCityForm",
  components: {
    InputSelect,
    InputText
  },
  props: {
    codePostal: {
      type: String,
      required: true
    },
    codePostalLabel: {
      type: String,
      required: true
    },
    codePostalSlug: {
      type: String,
      required: true
    },
    ville: {
      type: String,
      required: true
    },
    villeLabel: {
      type: String,
      required: true
    },
    villeSlug: {
      type: String,
      required: true
    },
    v$: {
      type: Object,
      required: true
    }
  },
  emits: [
    'updateCodePostal',
    'updateVille'
  ],
  setup (props, {emit}) {
    const {codePostal} = toRefs(props)

    // Logique concernant le code postal et les villes associées
    const {cities, getCities} = useCityRepositories(codePostal)

    // Si les villes sont MAJ, alors on met à jour le modèle avec la première ville retournée
    const citiesWatcher = watch(
        [() => cities.value],
        () => {
          if (cities.value.length > 0) {
            emit('updateVille', cities.value[0].value)
          }
    })

    return { cities, getCities, citiesWatcher}
  }
}
</script>

<style scoped>

</style>
